import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export default function EditorialSection() {
  const { settings, loading } = useSite();
  const e = settings.home.editorial;
  return (
    <section className="py-24 md:py-32 bg-ivory" data-testid="editorial-section">
      <div className="container-lux grid md:grid-cols-2 gap-12 md:gap-20 items-center">
        <div className="relative overflow-hidden aspect-[4/5] bg-muted">
          {loading || !e.image ? <div className="absolute inset-0 bg-muted animate-pulse" data-testid="editorial-image-loading" /> : <img src={e.image} alt="Editorial" className="w-full h-full object-cover" loading="lazy" />}
        </div>
        <div className="max-w-lg">
          <p className="overline text-muted-foreground">{e.kicker}</p>
          <h2 className="mt-6 font-serif tracking-tighter font-light text-5xl md:text-7xl leading-[0.95]">{e.title_line1}<br/><em className="not-italic">{e.title_line2}</em></h2>
          <p className="mt-8 text-muted-foreground leading-relaxed whitespace-pre-line">{e.description}</p>
          <div className="mt-10 flex flex-wrap gap-4">
            {e.cta_text && <Link to={e.cta_link || "/collections"} className="lux-btn-dark" data-testid="editorial-cta">{e.cta_text}</Link>}
            {e.cta2_text && <Link to={e.cta2_link || "/collections"} className="lux-btn-outline">{e.cta2_text}</Link>}
          </div>
          {e.stats?.length > 0 && <><div className="divider-thin mt-14" /><div className="mt-10 grid grid-cols-3 gap-8">{e.stats.map((s, i) => <div key={i}><p className="font-serif text-3xl md:text-4xl tracking-tighter">{s.value}</p><p className="overline mt-2 text-muted-foreground">{s.label}</p></div>)}</div></>}
        </div>
      </div>
    </section>
  );
}
